export default __webpack_public_path__ + "static/media/Letter Z.6997240e.mov";